import { NgClass } from '@angular/common';
import { Component, input, inject, computed } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CrntButtonAlt } from '@essent/current-web-angular';
import { ConsentService } from '@core/consent';
import { GenericLinkDirective } from '@core/jss-utils';
import { CONSENT_PARAM } from '@core/jss-seo';

@Component({
  selector: 'wl-video-player',
  standalone: true,
  imports: [NgClass, GenericLinkDirective, CrntButtonAlt],
  templateUrl: './video-player.component.html',
})
export class VideoPlayerComponent {
  readonly videoId = input.required<string>();
  readonly title = input.required<string>();
  readonly aspectRatio = input<string>('ratio-16x9');

  readonly #activatedRoute = inject(ActivatedRoute);
  readonly #sanitizer = inject(DomSanitizer);
  readonly #contentService = inject(ConsentService);

  readonly videoUrl = computed(() =>
    this.#sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube-nocookie.com/embed/${this.videoId()}`
    )
  );

  readonly imageUrl = computed(() =>
    this.#sanitizer.bypassSecurityTrustResourceUrl(
      `https://img.youtube.com/vi/${this.videoId()}/0.jpg`
    )
  );

  get allowsTrackingCookies() {
    return this.#contentService.allowsTrackingCookies();
  }

  get currentURL() {
    return this.#activatedRoute.snapshot.url.join('/');
  }

  get queryString() {
    const params = new URLSearchParams();
    params.set(CONSENT_PARAM, 'true');
    return params.toString();
  }
}
